import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createProject: {
		id: 'projects-directory-v3.page-layout.header.create-project-action.create-project',
		defaultMessage: 'Create project',
		description: 'Label of create project button',
	},
});
